import {Component} from '@angular/core';

@Component({
    selector: 'dk-harmonogram-history',
    template: require('./harmonogram-history.html'),
    entryComponents: [],
    inputs: ['harmonogram']
})

export class HarmonogramHistoryComponent {
    harmonogram: any;
}
